import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop is a component that automatically scrolls the window to the top
 * whenever the route changes. It should be added once near the root of the app.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // When the route changes, scroll to the top of the page
    window.scrollTo(0, 0);
  }, [pathname]);

  // This component doesn't render anything visible
  return null;
}
